import { apiClient } from "../config";
import { Course } from "../../../types/course";

export const getCourses = async (): Promise<Course[]> => {
  const { data } = await apiClient.get("/public/getTopCoursesPublished");
  return data;
};

export const getCoursePicture = async (courseId: number): Promise<string> => {
  const response = await apiClient.get(`/public/getCoursePics/${courseId}`, {
    responseType: "arraybuffer", // Important: Tell axios to expect binary data
  });

  // Convert binary data to base64
  const base64 = Buffer.from(response.data, "binary").toString("base64");
  const contentType = response.headers["content-type"] || "image/jpeg";

  // Create a data URL
  return `data:${contentType};base64,${base64}`;
};

export const getCourse = async (courseId: number): Promise<Course> => {
  const { data } = await apiClient.get(`/public/getIndvCourse/${courseId}`);
  return data;
};

export const enrollCourse = async (courseId: number): Promise<void> => {
  const { data } = await apiClient.post(`/student/chooseCourse/${courseId}/0`);
  return data;
};

export const getStudentRatingCourses = async (
  studentId: number
): Promise<Course[]> => {
  const { data } = await apiClient.get(
    `/public/getStudentRatingCourses/${studentId}`
  );
  return data;
};
